export default __webpack_public_path__ + "static/media/JASPE PAISAJE (CUADRO).4ae16ae0.jpg";